// eslint-disable-next-line no-restricted-imports
import { Box, Button } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { forwardRef } from 'react';
import { useContactModal } from 'src/hooks/useContactModal';
import { ContactModal } from 'src/components/molecules/ContactModal';

export const StickyRibbon = forwardRef<HTMLDivElement>((_, ref) => {
  const { onOpen, modalProps } = useContactModal({
    defaultInterest: 'demo',
    title: 'Book Demo',
    submitButtonText: 'Book Demo',
  });

  return (
    <>
      <Box ref={ref} position="fixed" bottom="16px" right="16px" zIndex="1000">
        <Button
          size="lg"
          variant="solid"
          bg="icon.green"
          color="white"
          _hover={{ bg: 'green.600' }}
          leftIcon={<Icon iconName="mail" fill="white" stroke="white" />}
          onClick={onOpen}
          boxShadow="lg"
          borderRadius="8px"
          px={8}
          py={4}>
          Book Demo
        </Button>
      </Box>
      <ContactModal {...modalProps} />
    </>
  );
});

StickyRibbon.displayName = 'StickyRibbon';
